<template>
    <v-row v-if="value">
        <v-col cols="4">
            <v-card>
                <v-card-title class="subtitle-2 font-weight-bold pb-0">기본정보1</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col class="pb-0">
                            <v-text-field label="업체이름" placeholder=" " hide-details v-model="value.meta.companyName"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field label="사업자등록번호" placeholder=" " hide-details v-model="value.meta.businessNumber"> </v-text-field>
                        </v-col>
                    </v-row>
                    <v-divider class="my-2" />
                    <v-row>
                        <v-col class="pb-0">
                            <v-text-field label="대표자" placeholder=" " hide-details v-model="value.name"> </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field label="인증연락처" placeholder=" " hide-details v-model="value.phone"> </v-text-field>
                        </v-col>
                    </v-row>
                    <v-divider class="my-2" />
                    <v-row>
                        <v-col class="pb-0">
                            <v-text-field label="고객센터전화번호" placeholder=" " hide-details v-model="value.meta.companyPhone"> </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field label="고객센터이메일" placeholder=" " hide-details v-model="value.meta.companyEmail"> </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="4">
            <v-card>
                <v-card-title class="subtitle-2 font-weight-bold pb-0">기본정보2</v-card-title>
                <v-card-text class="caption">
                    <v-row>
                        <v-col class="pb-0">
                            <v-text-field label="우편번호" placeholder=" " hide-details v-model="value.postcode"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pb-0">
                            <v-text-field label="기본주소" placeholder=" " hide-details v-model="value.address1"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field label="상세주소" placeholder=" " hide-details v-model="value.address2"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-divider class="my-2" />
                    <v-row>
                        <v-col class="pb-0">
                            <v-select v-model="value.meta.bankCode" :items="banks" item-text="name" item-value="code" label="은행명" placeholder=" " hide-details />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pb-0">
                            <v-text-field label="예금주" placeholder=" " hide-details v-model="value.meta.bankAccountName"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field label="계좌번호" placeholder=" " hide-details v-model="value.meta.bankAccount"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="4">
            <v-card>
                <v-card-title class="subtitle-2 font-weight-bold">기본정보3</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" class="py-0">
                            <v-row align="center">
                                <v-col cols="auto">회사로고</v-col>
                                <v-col cols="auto" v-if="isConsole || isCompany" class="py-0 pl-0">
                                    <v-file-input accept="image/*" hide-input hide-details class="pa-0 ma-auto" @change="saveLogo" />
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" class="pt-0">
                            <v-avatar color="grey lighten-2" tile width="100%" height="10rem">
                                <v-img v-if="meta.logo" :src="meta.logo" @click="showOverlay(meta.logo)" contain style="cursor:pointer" />
                                <v-col cols="auto" v-else>
                                    <v-file-input v-if="isConsole || isCompany" accept="image/*" prepend-icon="mdi-plus-circle" hide-input hide-details class="pa-0 ma-auto" @change="saveLogo" />
                                </v-col>
                            </v-avatar>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="py-0">
                            <v-row align="center">
                                <v-col cols="auto">사업자등록증</v-col>
                                <v-col cols="auto" v-if="isConsole || isCompany" class="py-0 pl-0">
                                    <v-file-input accept="image/*" hide-input hide-details class="pa-0 ma-auto" @change="saveBusinessRegistration" />
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" class="py-0">
                            <v-avatar color="grey lighten-2" tile width="100%" height="10rem">
                                <v-img v-if="meta.businessRegistration" :src="meta.businessRegistration" @click="showOverlay(meta.businessRegistration)" contain style="cursor:pointer" />
                                <v-col cols="auto" v-else>
                                    <v-file-input
                                        v-if="isConsole || isCompany"
                                        accept="image/*"
                                        prepend-icon="mdi-plus-circle"
                                        hide-input
                                        hide-details
                                        class="pa-0 ma-auto"
                                        @change="saveBusinessRegistration"
                                    />
                                </v-col>
                            </v-avatar>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import banks from "@/assets/data/banks.json";
import api from "@/api";
export default {
    props: {
        value: Object,
    },
    computed: {
        meta() {
            return this.value?.meta || {};
        },
        isConsole() {
            return this.$store.state.payload.scope.includes("console");
        },
        isCompany() {
            return this.$store.state.payload._user == this.$route.params._user;
        },
    },
    data() {
        return {
            banks,
            logo: null,
            businessRegistration: null,
        };
    },
    methods: {
        showOverlay(src) {
            if (src) this.$emit("showOverlay", src);
        },
        async saveLogo(file) {
            try {
                const refresh = !!this.meta?.logo;
                const { _id } = this.value || {};
                const { user } = await api.v1.users.postLogo({ _id }, file);
                this.$emit("input", user);
                alert("업로드 되었습니다.");
                if (refresh) this.$router.go();
            } catch (error) {
                this.$handleError(error);
            }
        },
        async saveBusinessRegistration(file) {
            try {
                const refresh = !!this.meta?.businessRegistration;
                const { _id } = this.value || {};
                const { user } = await api.v1.users.postBusinessRegistration({ _id }, file);
                this.$emit("input", user);
                alert("업로드 되었습니다.");
                if (refresh) this.$router.go();
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.meta-data-img-con {
    background-color: rgba(0, 0, 0, 0.1);
    background-size: contain;
    background-position: center;
    width: 100%;
    padding-top: calc(100% / 16 * 9);
}
</style>
